import React, { useState, useEffect } from "react";
import { Avatar, Box, Button, IconButton, Tooltip, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ReplyIcon from "@mui/icons-material/Reply";
import ConfirmationNumberOutlinedIcon from "@mui/icons-material/ConfirmationNumberOutlined";
import API from "../../../api";
import { palette } from "../../../theme";
import { Panel, MUTED, BORDER } from "../../dashboard/dashboard-components/resellerUi";
import { StatusBadge, TICKET_STATUS, formatDate } from "../ticketsUi";

const TicketDetails = ({
  data,
  id,
  subject,
  name,
  email,
  stato,
  tickets,
  setTickets,
  setCard,
}) => {
  const [message, setMessage] = useState("");

  useEffect(() => {
    API.getTicketsResDetail(id)
      .then((result) => {
        setMessage(result.data.messaggio);
      })
      .catch((error) => {
        console.error(
          "[TicketDetails] Si è verificato un errore durante il recupero dei dati:",
          error
        );
      });
  }, [id]);

  const handleBack = () => {
    setTickets(tickets);
    setCard(false);
  };

  const handleFinishSet = () => {
    API.putTicketState({ id: id, state: 3 }).then((response) => {
      setTickets(tickets);
      setCard(false);
      window.location.reload();
    });
  };

  const handleWorkingSet = () => {
    API.putTicketState({ id: id, state: 2 }).then((response) => {
      setTickets(tickets);
      setCard(false);
      window.location.reload();
    });
  };

  const status = TICKET_STATUS[stato];

  const actions = (
    <>
      <Button variant="outlined" size="small" onClick={handleWorkingSet}>
        Working
      </Button>
      <Button variant="outlined" size="small" onClick={handleFinishSet}>
        Finish
      </Button>
      <Button
        variant="contained"
        size="small"
        startIcon={<ReplyIcon />}
        component="a"
        href={"mailto:" + email}
      >
        Respond
      </Button>
    </>
  );

  return (
    <Panel
      icon={ConfirmationNumberOutlinedIcon}
      title="Ticket details"
      actions={actions}
      sx={{ height: "auto", minHeight: 0 }}
    >
      <Box sx={{ p: 2.5, display: "flex", flexDirection: "column", gap: 2.5 }}>
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
          <Tooltip title="Back to the list">
            <IconButton size="small" onClick={handleBack} aria-label="Back to the list" sx={{ mt: 0.25 }}>
              <ArrowBackIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Avatar sx={{ bgcolor: "rgba(69,144,149,0.14)", color: palette.primary.light, fontWeight: 700 }}>
            {(name || "?")[0].toUpperCase()}
          </Avatar>
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
              <Typography sx={{ fontSize: 18, fontWeight: 700, wordBreak: "break-word" }}>
                {subject || "(no subject)"}
              </Typography>
              {status && <StatusBadge color={status.color}>{status.label}</StatusBadge>}
            </Box>
            <Typography sx={{ fontSize: 14 }}>{name}</Typography>
            <Typography sx={{ fontSize: 13, color: MUTED }}>
              From{" "}
              <Box component="a" href={"mailto:" + email} sx={{ color: palette.primary.light, textDecoration: "none", "&:hover": { textDecoration: "underline" } }}>
                {email}
              </Box>
              {" · "}
              {formatDate(data)}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            minHeight: 150,
            maxHeight: "calc(100vh - 430px)",
            overflow: "auto",
            p: 2,
            border: `1px solid ${BORDER}`,
            borderRadius: "10px",
            backgroundColor: "rgba(255,255,255,0.02)",
          }}
        >
          <Typography sx={{ fontSize: 14, whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
            {message}
          </Typography>
        </Box>
      </Box>
    </Panel>
  );
};

export default TicketDetails;
